import { defaultCtx } from "~/lib/AjaxCtx"

export default class CommunicationService {
    constructor(ctx) {
        this.$http = ctx || defaultCtx
    }

    async getTools() {
        return await this.$http.fetchData("/communication-tools")
    }

    async getChannels() {
        return await this.$http.fetchData("/communication-channels")
    }

    async getPost(postId) {
        return await this.$http.fetchData(`/communication-posts/${postId}`)
    }

    async access(userActivityId) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}`
        )
    }
}
